module.exports = __webpack_public_path__ + "img/landos-slide__img.png?33a0e40bf2bec845f12dfaba3bea576f";